<template>
  <va-card :title="$t('menu.files')">
    <div class="row">
      <div class="flex xs6 sm3">
        <va-input
          :label="$t('forms.inputs.start_number')"
          v-model="start_number"
        />
      </div>
      <div class="flex xs6 sm3">
          <va-input
            :label="$t('forms.inputs.end_number')"
            v-model="end_number"
          />
          <p>O valor máximo permitido é 1000.</p>
      </div>
    </div>

      <div class="flex xs6 sm3">
        <va-button
          medium
          inline
          color="green"
          icon="fa fa-download"
          class="ma-0"
          @click="showConfirmExportQrcode = true"
        >

          {{ $t('menu.export_files') }}
        </va-button>
    </div>

    <va-modal
        v-model="showConfirmExportQrcode"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.showConfirmExportQrcode')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >
      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmExportQrcode = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="ExportQrcodePdfs(start_number, end_number), showConfirmExportQrcode = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>
  </va-card>
</template>

<script>

import SetupAPI from '@/services/SetupAPI'
import { http } from "@/services/config"
import { mapState } from "vuex"


export default {
  name: 'modals',
  data () {
    return {
      data: [],
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      filepath: "",
      start_number: "",
      end_number: "",
      showConfirmExportQrcode: false,
      renderComponent: true,
      currentDuration: 1500,
      showModal: false,
      currentDuration: 1500,
    }
  },

  watch: {
    '$store.state.currentLocality': function() {
      this.getDailyOperations(this.date, this.currentLocality.id)
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshLoads', company: this.currentUser.company })
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),
  },

  methods: {
    ExportQrcodePdfs (start_number, end_number) {
      SetupAPI.exportQrcodePdf(this.currentLocality.id, start_number, end_number).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
  },
}
</script>
